module.exports = {
	"en": {
		"static-pages": {
			"notFound": {
				"pageTitle": "Page Not Found",
				"title": "Not found",
				"details": "The application you're looking for is not found, are you sure you typed the address right?",
				"goBack": "Go back"
			},
			"activation": {
				"pageTitle": "Safe Zone",
				"title": "Welcome to the safe zone",
				"activate": {
					"details": "Just a second, we're preparing your activation link...",
					"ready": "Your link is ready, click the button to proceed. Note: this link is only usable once!",
					"go": "Activate account"
				},
				"passwordReset": {
					"details": "Just a second, we're preparing your password reset link...",
					"ready": "Your link is ready, click the button to proceed. Note: this link is only usable once!",
					"go": "Reset password"
				},
				"error": {
					"details": "It seems something is wrong with your link. Please try again, or contact support, referencing the code."
				}
			},
			"privacy-policy": {
				"pageTitle": "Privacy Policy for Merchant Portal"
			},
			"terms-and-conditions": {
				"pageTitle": "Merchant Portal Agreement"
			},
			"Support": {
				"pageTitle": "Support",
				"topic": {
					"orders": "Orders",
					"settlements": "Settlements",
					"agreements": "Agreements",
					"technical_issues": "Technical issues",
					"others": "Others"
				},
				"TicketList": {
					"title": "Support requests",
					"pageDescription": "Here you can view the status of your support requests",
					"status": {
						"open": "Open",
						"pending": "Pending",
						"resolved": "Resolved",
						"closed": "Closed",
						"inProgress": "In Progress",
						"waitingForYourReply": "Waiting For Your Reply"
					},
					"TicketTable": {
						"id": "Request #",
						"mid": "Store/MID",
						"subject": "Subject",
						"status": "Status",
						"updatedAt": "Last update"
					}
				},
				"EmptyTicketList": {
					"title": "You don't have any open requests"
				},
				"ticketDetails": {
					"sidebar": {
						"user": {
							"title": "User"
						},
						"details": {
							"title": "Details",
							"store": "Store/MID",
							"createdAt": "Request date",
							"updatedAt": "Last update"
						},
						"actions": {
							"close": "Close Request",
							"reopen": "Reopen Request"
						},
						"closeTicketDialog": {
							"confirm": "Confirm",
							"title": "Close request",
							"description": "You are about to close this request. You will be able to reopen it within the next 7 days only.",
							"error": "Oops! Something went wrong, try again."
						},
						"reopenTicketDialog": {
							"title": "Reopen request",
							"description": "Tell us more why you need to reopen this request and we'll get back to you shortly.",
							"messageLabel": "Message"
						}
					},
					"conversation": {
						"loadMore": "Load more",
						"title": "Request",
						"attachments": {
							"label": "Attachments"
						},
						"reply": {
							"title": "Add Reply",
							"body": {
								"label": "Add a reply",
								"error": null
							},
							"attachment": {
								"label": "Add attachments",
								"error": "Total files size may not exceed 15 MB"
							},
							"add": "Add Reply",
							"cancel": "Cancel",
							"submit": {
								"label": "Submit",
								"error": "Error saving reply, please try again later"
							}
						}
					}
				},
				"errorView": {
					"429": {
						"title": "Ouch!",
						"message": "Something went wrong, try again in a few minutes. If the problem persists, contact us for help.",
						"contact": "When contacting support, please supply the following correlation ID",
						"action": "Contact Us"
					},
					"error": "Error",
					"default": {
						"title": "Oops, something went wrong",
						"message": "For some reason on our side, we weren't able to run you request. You can try again or come back later.",
						"contact": "When contacting support, please supply the following correlation ID",
						"action": "Refresh"
					}
				}
			},
			"Marketing": {
				"pageTitle": "Grab and Go Marketing",
				"banner": {
					"title": "Welcome to Grab and Go Marketing!",
					"subtitle": "Here is where you'll find ready-to-use assets for your website, email campaigns and social media marketing.",
					"button": "Learn more"
				},
				"productSection": {
					"title": "Which Klarna product do you offer to shoppers?"
				},
				"MarketSelector": {
					"label": "Select market",
					"markets": {
						"BE": "Belgium (Dutch)",
						"BE-FR": "Belgium (French)"
					}
				},
				"ChannelSelector": {
					"pageTitle": {
						"kco": "Klarna Checkout",
						"fourInstallments": "4 Installments",
						"pin30": "Pay in 30 days"
					}
				},
				"sourceAndPreview": {
					"helpButton": "Need help using this?",
					"copyButton": "Copy to clipboard",
					"copyButtonSuccess": "Copied!",
					"sourceButton": "Source",
					"previewButton": "Preview"
				},
				"EmailTemplates": {
					"pageTitle": "Email templates",
					"title": "Email templates"
				},
				"EmailHeader": {
					"pageTitle": "Email marketing image",
					"title": "Email marketing image"
				},
				"Social": {
					"pageTitle": "Social media",
					"title": "Social media"
				},
				"buttonDownload": "Download image",
				"buttonCopy": "Copy text",
				"buttonCopySuccess": "Copied!",
				"missingPreview": "Missing preview",
				"productLinkText": "Grab assets",
				"content": {
					"products": {
						"kco": {
							"title": "Klarna Checkout",
							"subtitle": "A complete checkout solution with everything in one place."
						},
						"payNow": {
							"title": "Pay now",
							"subtitle": "Let shoppers pay for their purchase on the spot."
						},
						"threeInstallments": {
							"title": "3 Installments",
							"subtitle": "Give shoppers the freedom to spread the cost interest-free over time."
						},
						"fourInstallments": {
							"title": "4 Installments",
							"subtitle": "Give shoppers the freedom to spread the cost interest-free over time."
						},
						"pin14": {
							"title": "Pay in 14 days",
							"subtitle": "Pay in 14 days. No interest or added fees."
						},
						"pin21": {
							"title": "Pay in 21 days",
							"subtitle": "Pay in 21 days. No interest or added fees."
						},
						"pin30": {
							"title": "Pay in 30 days",
							"subtitle": "Pay in 30 days. No interest or added fees."
						},
						"financing": {
							"title": "Financing",
							"subtitle": "Boost your sales by offering customers up to 36 months to pay."
						}
					},
					"campaigns": {
						"holidays-2020": {
							"title": "Holidays 2020",
							"channels": {
								"emailHeader": {
									"title": "Email marketing image",
									"subtitle": "Make subscribers look twice this Holiday Season with studio-quality images for your email campaigns.",
									"linkText": "View images",
									"introduction": "It's time to let your subscribers know all about your amazing Holiday Season offers and discounts. Download an image and add it to your email campaign or email template header for the biggest impact."
								},
								"social": {
									"title": "Social media",
									"subtitle": "Drive more shoppers to your store during the Holiday Season with these free-to-use images.",
									"linkText": "View posts",
									"introduction": "It's time to spread the word about your awesome Holiday Season offers and discounts! Simply download the assets and upload them to your social media profiles or scheduling tool. Remember to tag {link} in your announcements to reach even more shoppers and conversions."
								}
							},
							"imageAlt": {
								"holiday1": "Person in a blue, pink and silver bodysuit slides on one knee towards a mop; one arm held out on a silver shoe and the other holding a smartphone.",
								"holiday2": "Person in burgundy satin pajamas sits cross-legged, hovering above a desk fan with a smartphone floating at eye-level."
							}
						},
						"at-launch": {
							"title": "At launch",
							"subtitle": "Just started your journey with us? Use these assets to announce to shoppers, old and new, that you're live with Klarna.",
							"channels": {
								"email": {
									"title": "Email templates",
									"subtitle": "Let your subscribers know that there's a new way to pay at checkout.",
									"linkText": "View templates",
									"introduction": "It's time to announce to your subscribers that you've launched with Klarna! Simply copy and paste the template or content to your email platform, and you're good to go.",
									"codeBoxTitle": "Launch email"
								},
								"social": {
									"title": "Social media",
									"subtitle": "Drive more shoppers to your store with these smoooth studio-quality pics.",
									"linkText": "View posts",
									"introduction": "It's time to announce to the world that you've launched with Klarna! Simply download the assets and upload them to your social media profiles or scheduling tool. Remember to tag {link} in your announcements to reach even more shoppers and conversions."
								},
								"osm": {
									"title": "Landing pages",
									"subtitle": "Stay compliant and inform shoppers about how to shop with Klarna.",
									"linkText": "View pages"
								}
							},
							"imageAlt": {
								"emotional": "Person with long, curly hair in purple jumpsuit playing a chrome pinball machine",
								"paymentShowcase": "A hand holding a phone showing the Klarna logo, roller skates in the background",
								"simplified": "Face-down phone on a chrome pinball machine on the right, bright yellow sofa on the left",
								"device": "A phone showing the Klarna logo dangling from off-picture, pink room with chandelier in the background"
							}
						}
					}
				}
			}
		}
	}
};